import { Box, Image, Text, Tooltip } from '@chakra-ui/react';
import Map from '../../components/map/Map';
import { Sidebar } from '../../components/sidebar/Sidebar';
import { Icon } from '@blueprintjs/core';
import { useContext } from 'react';
import UIContext from '../../context/UIContext';
import AttributionsModal from '../../components/AttributionsModal';

function RootScreen() {
    const {
        attributionsOpen, setAttributionsOpen
    } = useContext(UIContext);

    return (
        <Box position="absolute" top="0px" bottom="0px" left="0px" right="0px" display="flex" flexDir="row">
            <Sidebar></Sidebar>
            {/* <Box
                bg="black"
                position="absolute"
                top="10px"
                right="10px"
                w="30px"
                h="30px"
                zIndex={2}
                display="flex"
                flexDir="row"
                justifyContent="center"
                alignItems="center"
                borderRadius="4px"
                boxShadow="0px 0px 0px 2px rgba(0,0,0,0.1)"
                cursor="pointer"
                // opacity="0.5"
            >
                <Image src="/public/img/logo-icon.svg" w="16px"></Image>
            </Box> */}

            <Tooltip placement="right" label="Data Attributions">
            <Box
                bg="white"
                position="absolute"
                bottom="10px"
                left="10px"
                w="30px"
                h="30px"
                zIndex={2}
                display="flex"
                flexDir="row"
                justifyContent="center"
                alignItems="center"
                borderRadius="4px"
                boxShadow="0px 0px 0px 2px rgba(0,0,0,0.1)"
                cursor="pointer"
                _hover={{
                    bg: "rgba(245,245,245,1.0)"
                }}
                onClick={() => {
                    setAttributionsOpen(true);
                }}
            >
                <Text mb="0px" opacity="0.4">
                <Icon icon="info-sign"></Icon>
                </Text>
            </Box>
            </Tooltip>
            <Map></Map>
            <AttributionsModal isOpen={attributionsOpen} onClose={() => setAttributionsOpen(false)}></AttributionsModal>
        </Box>
    );
}

export default RootScreen;
